export default __webpack_public_path__ + "static/media/GroupTablDark.31d6b5e9.png";